import { AboutMeTemplate } from "../components/template/AboutMeTemplate"

export const AboutMe = () => {
    return(
        <>
            <AboutMeTemplate />
        </>
    )
}